import React, { useRef, useState } from "react";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import pdfWorker from "pdfjs-dist/build/pdf.worker?worker";

// Set the worker source
GlobalWorkerOptions.workerSrc = pdfWorker;

const PDFUpload = ({ onUpload }) => {
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
    const reader = new FileReader();

    reader.onload = async () => {
      try {
        const typedArray = new Uint8Array(reader.result);
        const pdf = await getDocument(typedArray).promise;

        let fullText = "";

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const content = await page.getTextContent();
          const text = content.items.map((item) => item.str).join(" ");
          fullText += text + "\n";
        }

        console.log("Extracted PDF Text:", fullText); // optional debug
        onUpload(fullText); // ✅ Trigger next step
      } catch (error) {
        console.error("Error extracting PDF text:", error);
        alert("Could not extract text from the PDF. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <input
        type="file"
        accept="application/pdf"
        ref={inputRef}
        onChange={handleFileChange}
        className="hidden"
      />
      <button
        onClick={() => inputRef.current.click()}
        className="bg-violet-600 hover:bg-violet-700 text-white px-6 py-3 rounded-xl shadow-lg transition duration-300 ease-in-out"
      >
        📄 Upload Resume PDF
      </button>
      {loading && (
        <p className="mt-4 text-gray-600 animate-pulse">
          Extracting content...
        </p>
      )}
    </div>
  );
};

export default PDFUpload;
